import { FC, useEffect, useState } from "react"
import { getSummaryTablesSelector } from "../../../api/transport/statsTransport"
import { ConfigProvider, Select } from "antd";
import { SummaryTableSelectorDto } from "../../../types/stats/summaryTables";
import { Dropdown } from "../../../components/ui-kit";

interface SummaryTableSelectorProps {
    tableId?: number;
    onSelect: (summaryTableId: number) => void;
}

export const SummaryTableSelector: FC<SummaryTableSelectorProps> = ({
    onSelect,
}) => {
    const [selectorData, setSelectorData] = useState<SummaryTableSelectorDto>();
    const [seasonsOptions, setSeasonsOptions] = useState<{ label: string, value: string }[]>([]);
    const [tableOptions, setTableOptions] = useState<{ label: string, value: string }[]>([]);
    const [selectedSeason, setSelectedSeason] = useState<string>();
    const [selectedTable, setSelectedTable] = useState<string>();

    useEffect(() => {
        getSummaryTablesSelector().then(data => {
            setSelectorData(data);
            const urlParams = new URLSearchParams(window.location.search);
            const urlTableId = urlParams.get('shows');
            const seasons = Object.keys(data);

            let seasonToSelect = seasons[0];
            if (urlTableId) {
                seasonToSelect = seasons.find(season => {
                    return !!data[season].find(table => {
                        return table.id === Number(urlTableId);
                    });
                })
            }

            setSeasonsOptions(Object.keys(data).map((season) => ({ label: season, value: season })));
            setSelectedSeason(seasonToSelect);

            const tables = data[seasonToSelect];
            setTableOptions(tables.map((table) => ({ label: table.name, value: table.id.toString() })));
            setSelectedTable(urlTableId || tables[0].id.toString());

            onSelect(+urlTableId || tables[0].id);
        });
    }, []);

    const onSelectSeason = (season: string) => {
        setSelectedSeason(season);
        const tables = selectorData[season];
        setTableOptions(tables.map((table) => ({ label: table.name, value: table.id.toString() })));
        setSelectedTable(tables[0].id.toString());
        onSelect(tables[0].id);
    }

    const onSelectTable = (tableId: string) => {
        setSelectedTable(tableId);
        onSelect(+tableId);
    }

    return (

        <div className="flex flex-col sm:flex-row items-center justify-center sm:justify-start gap-1 flex-wrap">
            <Dropdown
                items={seasonsOptions}
                onSelect={onSelectSeason}
                defaultValue={selectedSeason}
            />
            <Dropdown
                items={tableOptions}
                onSelect={onSelectTable}
                defaultValue={selectedTable?.toString()}
            />
        </div>
    )
}
